import React, { FC } from 'react';

import IconButton from '@zvuk-b2b/react-uikit/ui/IconButton';
import IconChevronLeft from '@zvuk-b2b/react-uikit/ui/icons/ChevronLeft';
import IconChevronRight from '@zvuk-b2b/react-uikit/ui/icons/ChevronRight';

import { TEXTS } from './texts';

import styles from './index.module.scss';

type ListSliderProps = {
  isLeftDisabled: boolean;
  isRightDisabled: boolean;
  onLeftClick: () => void;
  onRightClick: () => void;
};

const ListSlider: FC<ListSliderProps> = ({ isLeftDisabled, isRightDisabled, onLeftClick, onRightClick }) => (
  <div className={styles.ListSlider}>
    <h3 className={styles.ListSliderTitle}>{TEXTS.LIST_SLIDER_TITLE}</h3>
    <div className={styles.ListSliderIconsContainer}>
      <IconButton
        elementId="payment_method_list_slider_left_button"
        className={styles.ListSliderIcon}
        isDisabled={isLeftDisabled}
        onClick={onLeftClick}>
        <IconChevronLeft />
      </IconButton>
      <IconButton
        elementId="payment_method_list_slider_right_button"
        className={styles.ListSliderIcon}
        isDisabled={isRightDisabled}
        onClick={onRightClick}>
        <IconChevronRight />
      </IconButton>
    </div>
  </div>
);

export default React.memo(ListSlider);
